"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pagination = void 0;
require("./pagination.scss");
var pagination = {
    init: function () {
        pagination.navigatePagination();
        pagination.setPaginationDefault();
        pagination.setPaginationButtons();
        pagination.clickPaginationScroll();
    },
    navigatePagination: function () {
        var paginationItems = document.querySelectorAll(".pagination__item[data-page]");
        paginationItems.forEach(function (paginationItem) {
            paginationItem.addEventListener("click", function (e) {
                e.preventDefault();
                navigate(e);
            });
            paginationItem.addEventListener("touchstart", function (e) {
                e.preventDefault();
                navigate(e);
            });
        });
        function navigate(p) {
            var target = p.target;
            if (target) {
                var dataItem = target.dataset.page;
                var urlParams = new URLSearchParams(window.location.search);
                if (window.location.search === "") {
                    window.location.href = "?page=".concat(dataItem);
                }
                else {
                    var hasPagination = urlParams.has("page");
                    if (hasPagination) {
                        urlParams.set('page', dataItem);
                        var urlString = urlParams.toString();
                        window.location.href = window.location.pathname + "?".concat(urlString);
                    }
                    else {
                        window.location.href = window.location.href + "&page=".concat(dataItem);
                    }
                }
            }
        }
    },
    setPaginationDefault: function () {
        var slider = document.getElementById("pagination-slider");
        if (slider !== null) {
            var currentItem = document.querySelector(".pagination__item.active");
            if (currentItem !== null) {
                var parentItem = currentItem.closest(".pagination-slide");
                if (parentItem) {
                    var currentSlide = parentItem.getAttribute("data-slide");
                    slider.style.setProperty("--slider__index", currentSlide);
                }
            }
        }
    },
    setPaginationButtons: function () {
        var slider = document.getElementById("pagination-slider");
        if (slider !== null) {
            var sliderIndex = parseInt(getComputedStyle(slider).getPropertyValue("--slider__index"));
            var buttonPrev = document.getElementById("pagination-prev");
            var buttonNext = document.getElementById("pagination-next");
            var slides = Number(slider.querySelectorAll(".pagination-slide").length);
            if (buttonPrev && buttonNext) {
                var slidesAmount = slides - 1;
                if (slidesAmount === 0) {
                    buttonPrev.setAttribute("disabled", "");
                    buttonNext.setAttribute("disabled", "");
                }
                else if (slidesAmount > 0) {
                    if (sliderIndex === 0) {
                        buttonPrev.setAttribute("disabled", "");
                        buttonNext.removeAttribute("disabled");
                    }
                    if (sliderIndex > 0 && sliderIndex < slidesAmount) {
                        buttonPrev.removeAttribute("disabled");
                        buttonNext.removeAttribute("disabled");
                    }
                    if (sliderIndex === slidesAmount) {
                        buttonPrev.removeAttribute("disabled");
                        buttonNext.setAttribute("disabled", "");
                    }
                }
            }
        }
    },
    clickPaginationScroll: function () {
        var slider = document.getElementById("pagination-slider");
        var buttonPrev = document.getElementById("pagination-prev");
        var buttonNext = document.getElementById("pagination-next");
        var sliderIndex;
        if (slider) {
            sliderIndex = parseInt(getComputedStyle(slider).getPropertyValue("--slider__index"));
        }
        if (buttonPrev && buttonNext) {
            buttonPrev.addEventListener("click", function () {
                if (slider && sliderIndex) {
                    sliderIndex = sliderIndex - 1;
                    slider.style.setProperty("--slider__index", sliderIndex.toString());
                    pagination.setPaginationButtons();
                }
            });
            buttonNext.addEventListener("click", function () {
                sliderIndex = sliderIndex + 1;
                if (slider) {
                    slider.style.setProperty("--slider__index", sliderIndex.toString());
                    pagination.setPaginationButtons();
                }
            });
        }
    }
};
exports.pagination = pagination;
